// tslint:disable-next-line:max-line-length
export const HERO_CONTENT_DRIVING = `Sign up now to become a Dasher with DoorDash! Start delivering today and make great money on your own schedule.`
export const HERO_CONTENT_CITY = `Are you looking for a full-time or part-time job in {CITY}? Deliver with DoorDash instead and be your own boss. Work when you want, wherever you want. Sign up today.`

export const HERO_TITLE_CITY = `Driving Opportunities`
export const HERO_TITLE_DEFAULT = `Driving Opportunities With DoorDash`
